import MenuItem from './MenuItem.js';
import UiAction from './UiAction.js';
import UiPage from './UiPage.js';
import UiRoute from './UiRoute.js';
export default class UiManager {
  constructor() {
    this.menuItems = [];
    this.menuItemsByActionName = {};
    this.uiRoutes = [];
  }

  addUiPage = (pageComponent, pageName) => {
    return new UiPage(pageComponent, pageName);
  }

  addUiAction = (actionName) => {
    return new UiAction(actionName);
  }

  addUiRoute = (path, uiPageName) => {
    const uiRoute = new UiRoute(path, UiPage.byPageName[uiPageName]);
    this.uiRoutes.push(uiRoute);
    return uiRoute;
  }

  addMenuItem = (label, actionName, pageName) => {
    const uiAction = UiAction.byActionName[actionName];
    const uiPage = UiPage.byPageName[pageName];
    const uiRoute = pageName ? uiPage.uiRoute : null;
    if(uiPage) {
      UiAction.byActionName[actionName].linkUiPage(uiPage);
    }
    var menuItem = new MenuItem(label, uiAction, uiRoute)
    this.menuItems.push(menuItem)
    this.menuItemsByActionName[actionName] = menuItem;
    return menuItem;
  }

  getMenuItem = (actionName) => {
    return this.menuItemsByActionName[actionName];
  }

  getTopLevelMenuItems = () => {
    return this.menuItems.filter((menuItem) => !menuItem.parentMenuItem)
  }

  getUiPage = (pageName) => {
    return UiPage.byPageName[pageName];
  }

  getUiAction = (actionName) => {
    return UiAction.byActionName[actionName];
  }

  linkUiActionToPage = (uiActionName, uiPage) => {
    UiAction.byActionName[uiActionName].linkUiPage(uiPage);
  }
}
